import { BaseSelect } from '@app/components';
import { variationApi } from '@app/store/services/variation';
import { createColumnHelper } from '@tanstack/react-table';
import { IVariation } from '@app/common';
import React from 'react';
import { ResourceSelect, ResourceSelectParentProps } from '../ResourceSelect';

const columnHelper = createColumnHelper<IVariation>();

export const VariationSelect = ({ label = 'Variations', ...props }: ResourceSelectParentProps<IVariation>) => {
  const columns = [
    columnHelper.accessor('name', {
      header: () => (
        <BaseSelect.ListHeaderItem width="100%">
          Nom
        </BaseSelect.ListHeaderItem>
      ),
      cell: (info) => (
        <BaseSelect.ListItemCol width="100%">
          <BaseSelect.ListItemText numberOfLines={1} bold>
            {info.getValue()}
          </BaseSelect.ListItemText>
        </BaseSelect.ListItemCol>
      ),
    }),
  ];

  return (
    <ResourceSelect
      label={label}
      columns={columns}
      useQuery={variationApi.useReadManyVariationQuery}
      {...props} />
  );
};
